import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
  SecurityContext,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TrainingApiService } from '../../../services/data/training-api.service';
import { ITraining } from '../../../models/training.interface';
import {
  AppLoadService,
  IContact,
  IUser,
  quizService
} from '@ebb-v2/ebb-integration';
import { Observable } from 'rxjs';
import { cloneDeep } from '@apollo/client/utilities';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { VideoModalDialogComponent } from './video-modal-dialog.component';
import { take } from 'rxjs/operators';
import { PdfModalComponent } from './pdf-modal.component';

// Interfaces

@Component({
  selector: 'ebb-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss']
})
export class TrainingComponent implements OnInit {
  @Input('trainingType') trainingType: string;
  @Input('currentUser') currentUser: IUser;

  quizWindow = null;
  public pageTitle = 'Training';
  public listTraining: ITraining[] = [];
  public apiurl: string;
  public http: any;
  public showPopup: boolean = false;
  public isess: boolean = false;
  public isemr: boolean = false;
  public currentquiznumber: number = null;

  public step = 0;
  public videoUrl: string = ''; //
  constructor(
    private readonly router: Router,
    private route: ActivatedRoute,
    private apitraining: TrainingApiService,
    private readonly apiAppSettings: AppLoadService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private readonly apiquiz: quizService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    const envSettings = this.apiAppSettings.readEnvironSettings();
    this.apiurl = `${envSettings.uriApiRoot}/files/training`;

    if (this.trainingType === '700000001') {
      this.isess = true;
    }
    if (this.trainingType === '700000002') {
      this.isemr = true;
    }
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  ngOnInit() {
    if (this.trainingType === '700000001') {
      this.isess = true;
    }
    if (this.trainingType === '700000002') {
      this.isemr = true;
    }
    this.loadtraining(this.trainingType);
  }

  public UpdatequizShow(quizNumber: number, show: boolean): boolean {
    const indexToUpdate = this.listTraining.findIndex(
      x => x.trainingQuizNumber == quizNumber
    );
    if (indexToUpdate !== -1) {
      return this.listTraining[indexToUpdate].isPassed;
    }
    return false;
  }
  public checkquizByNumber(quizNumber: number): boolean {
    const indexToUpdate = this.listTraining.findIndex(
      x => x.trainingQuizNumber == quizNumber
    );
    if (indexToUpdate !== -1) {
      return this.listTraining[indexToUpdate].isPassed;
    }
    return false;
  }
  public getrefreshQuiz(isess: boolean): void {
    {
      this.apiquiz
        .getrefreshQuiz(isess)

        .pipe(take(1))
        .subscribe((getrefreshQuiz: any) => {
          console.log(getrefreshQuiz);
          const quizresults: Record<string, boolean> = getrefreshQuiz;

          for (const key in quizresults) {
            if (quizresults.hasOwnProperty(key)) {
             
              const value = quizresults[key];

              this.UpdateQuizResults(key, value);
            }
          }
        });
    }
  }
  public loadTaskStatusIconHtml(status: boolean, quizNumber: number): string {
    var _quizNumber = quizNumber;
    let iconName = 'fa-solid fa-square-1 fa-sm';
    var checkbox = 'fa-solid fa-square-check fa-sm';
    var warning = 'fa-solid fa-triangle-exclamation fa-sm';

    iconName =
      status == true
        ? checkbox
        : status == false
        ? warning
        : iconName.replace('1', _quizNumber.toString());

    return "<i class='" + iconName + "'/>";
  }

  public UpdateQuizResults(key: string, value: boolean) {
    const indexToUpdate = this.SetQuizResults(key, value);
    this.listTraining[indexToUpdate].isshowQuiz = false;
    if (this.listTraining[indexToUpdate].isPassed === true) {
      this.listTraining[indexToUpdate].isshowQuiz = false;
    } else {
      if (indexToUpdate === 0) {
        this.listTraining[indexToUpdate].isshowQuiz = true;
        this.step = indexToUpdate;
      }
      if (indexToUpdate > 0) {
        if (this.step == 0 && this.listTraining[0].isshowQuiz !== true) {
          this.step = indexToUpdate;
          this.listTraining[indexToUpdate].isshowQuiz = true;
        }
      }
    }
  }
  private SetQuizResults(key: string, value: boolean) {
    const indexToUpdate = this.listTraining.findIndex(
      x => x.trainingQuizNumber == Number.parseInt(key)
    );
    if (indexToUpdate !== -1) {
      if (value) {
        this.listTraining[indexToUpdate].isPassed = value;
      } else {
        if (value === false) {
          this.listTraining[indexToUpdate].isPassed = false;
        } else {
          this.listTraining[indexToUpdate].isPassed = null;
        }
      }
    }
    return indexToUpdate;
  }
  public getStyleObject(isPassed) {
    if (isPassed == true) {
      return { 'background-color': '#y' };
    } else if (isPassed == false) {
      return { 'background-color': '#f44336' };
    }
  }
  public quizsectionStatus(isPassed) {
    if (isPassed == true) {
      return 'retrofit-task-icon accepted';
    } else if (isPassed == false) {
      return 'retrofit-task-icon rejected';
    } else {
      return 'retrofit-task-icon primary';
    }
  }
  public UpdateQuiz(quizId: number, result: boolean, isess: boolean) {
    this.apiquiz
      .updateQuizStatus(this.currentquiznumber, result, this.isess)

      .pipe(take(1))
      .subscribe((getrefreshQuiz: any) => {
        this.step = 0;
        this.getrefreshQuiz(this.isess);
      });
  }

  private loadtraining(Type: string): void {
    if (Type === '700000001') {
      this.isess = true;
    }
    if (Type === '700000002') {
      this.isemr = true;
    }
    this.apitraining.getList(Type).subscribe(
      _data => {
        var data = cloneDeep(_data);
        if (data.length > 0) {
          data = data.sort(
            (a, b) => a.trainingQuizNumber - b.trainingQuizNumber
          );
          this.listTraining = JSON.parse(JSON.stringify(data));
          if (this.currentUser != null) {
            this.getrefreshQuiz(this.isess);
          }
          this.listTraining.forEach(training => {
            training.pdfUrl = this.GetUrl(training.pdfUrl);
            training.videoTeaserImage = this.GetUrl(training.videoTeaserImage);
            training.videoUrl = this.sanitizer.sanitize(
              SecurityContext.URL,
              training.videoUrl
            );
            training.trainingFile = this.GetUrl(training.trainingFile);
          });
        }
      },
      error => console.log(error)
    );
  }
  private GetUrl(filepath): string {
    var url = '';
    if (filepath != null && filepath.length > 0) {
      url = `${this.apiurl}/${filepath}`;
      var outputURL = this.sanitizer.sanitize(SecurityContext.URL, url);
      return outputURL;
    } else {
      url = '';
    }

    return url;
  }
  public GetFile(filepath): Observable<Blob> {
    let url = '';

    url = `${this.apiurl}/${filepath}`;

    console.debug(`GET file ${url}`);
    var getFile = this.http.get(url, {
      headers: { 'Access-Control-Allow-Origin': '*' },
      withCredentials: true,
      responseType: 'blob'
    });
    return getFile;
  }
  public playVideo(url) {
    this.videoUrl = url; // Replace with your YouTube or Vimeo video URL
  }
  openPopup() {
    this.showPopup = true;
  }

  openURL(url) {
    // Define the URL you want to open in a new tab
    const urlToOpen = url;

    // Open the URL in a new tab
    window.open(urlToOpen, '_blank');
  }

  public openModal(url): void {
    const dialogRef = this.dialog.open(VideoModalDialogComponent, {
      data: { videoUrl: url },

      width: '600px',
      height: '560px'
    });
  }
  public openPdfModal(url): void {
    const dialogRef = this.dialog.open(PdfModalComponent, {
      data: { url: url },

      width: '1200px',
      height: '800px'
    });
  }
  public getquiz(quizNumber) {
    var training = this.listTraining.filter(
      x => x.trainingQuizNumber == quizNumber
    );

    return training;
  }
  public openquiz(quizNumber) {
    var training = this.listTraining.filter(
      x => x.trainingQuizNumber == quizNumber
    );
    this.currentquiznumber = training[0].trainingQuizNumber;

    this.quizWindow = window.open(
      encodeURI(training[0].trainingFile.toString()),
      'FEMA Quiz: ' + quizNumber,
      'directories=no,titlebar=no,toolbar=no,location=no,status=no,' +
        'menubar=no,scrollbars=no,resizable=no,width=600,height=450'
    );
    window.addEventListener('message', this.onMessage, false);
  }

  @HostListener('window:message', ['$event'])
  public onMessage(event) {
    // Handle the message received from the child window

    var canupdate = false;
    var result;
    if (event.data === 'Passed') {
      console.log(event.data);
      canupdate = true;
      result = true;
    }

    if (event.data === 'Failed') {
      console.log(event.data);
      canupdate = true;
      result = false;
    }

    if (canupdate) {
      this.UpdateQuiz(this.currentquiznumber, result, this.isess);
    }
  }
}
